import z from 'zod';
import { businessSchema, productSchema } from '../../common/app-registry.schema';

/**
 * What the lead is interested in. Drives which follow-up flow / sales
 * playbook to run. Leads can carry multiple interests.
 *
 * Includes every **business** id and every **product** (audience offering)
 * id so filters can answer both "which brand" and "enterprise vs freelancer".
 */
export const leadInterestSchema = z.enum([
  'book_demo',
  'request_quote',
  'self_signup',
  'partnership',
  'financing',
  'fleet_management',
  'generic',
  ...businessSchema.options,
  ...productSchema.options,
]);

export type LeadInterest = z.infer<typeof leadInterestSchema>;
